'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { useLocale } from '@src/i18n/LocaleProvider';
interface SearchModalRecentSearchesProps {
  recentSearches: string[];
  handleSuggestionClick: (suggestion: string) => void;
  onClearAll: () => void;
}
export function SearchModalRecentSearches(props) {
  const $ = _c(22);
  const {
    recentSearches,
    handleSuggestionClick,
    onClearAll
  } = props;
  const {
    t
  } = useLocale("search");
  let t0;
  if ($[0] !== t) {
    t0 = t("recent-searches");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <span className="text-body-base font-medium text-bodi-gray-medium">{t0}</span>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("clear-all");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onClearAll || $[7] !== t2) {
    t3 = <button type="button" onClick={onClearAll} className="text-body-base font-medium text-bodi-accent-deep-500 underline">{t2}</button>;
    $[6] = onClearAll;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="flex items-center justify-between">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleSuggestionClick || $[13] !== recentSearches) {
    let t6;
    if ($[15] !== handleSuggestionClick) {
      t6 = term => <li key={term}><button onClick={() => handleSuggestionClick(term)} className="flex w-full items-center justify-between rounded-lg py-0.5 text-body-base text-bodi-black"><span>{term}</span><ArrowUpRightIcon className="size-3.5 shrink-0 text-bodi-gray-butters" /></button></li>;
      $[15] = handleSuggestionClick;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t5 = recentSearches.map(t6);
    $[12] = handleSuggestionClick;
    $[13] = recentSearches;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[17] !== t5) {
    t6 = <ul>{t5}</ul>;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t6) {
    t7 = <div className="flex flex-col gap-2">{t4}{t6}</div>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}